import React, { useCallback, useRef, useMemo } from 'react'
import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Sheet from 'components/utils/Sheet'
import MerchandiseSearchForm from '../MerchandiseSearch/MerchandiseSearchForm'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'
import useMerchandiseBrands from 'hooks/Merchandise/useMerchandiseBrands'

const SearchPlaceholderTextList: Array<string> = ['marketplace']

function MerchandiseLandingPageSearchBar() {
  const [brandListIds] = useMerchandiseBrandsList({ sortBy: 'top' })
  const [brands] = useMerchandiseBrands(brandListIds)

  const containerRef = useRef<HTMLDivElement>(null)
  const onInputClick = useCallback(() => {
    containerRef.current?.scrollIntoView()
  }, [])

  const searchPlaceholderTextList = useMemo(() => {
    return brands.length ? brands.map(brand => `products in ${brand.name}`) : SearchPlaceholderTextList
  }, [brands])

  return <>
    <CSSBreakpoint max="tablet">
      <GlobalMobileSearchHeroBar
        placeholder="Search"
        placeholderTextList={searchPlaceholderTextList}
      />
    </CSSBreakpoint>
    <CSSBreakpoint min="tablet">
      <Sheet ref={containerRef} padding={16} background="neutral-eight" shadow="flat-small">
        <MerchandiseSearchForm onInputClick={onInputClick} />
      </Sheet>
    </CSSBreakpoint>
  </>
}

export default MerchandiseLandingPageSearchBar
